export const spanishMenu = [
  {
    path: "/dashboard",
    icon: "fa fa-th",
    title: "Tablero",
  },
  {
    path: "/maintenance",
    icon: "ion-md-construct",
    title: "Ticket de mantenimiento",
  },
  {
    path: "/payments",
    icon: "fa fa-dollar-sign",
    title: "Pagos",
  },
  // parking hidden until post-7th deploy
];

export const Menu = [
  {
    path: "/dashboard",
    icon: "fa fa-th",
    title: "Dashboard",
  },
  {
    path: "/maintenance",
    icon: "ion-md-construct",
    title: "Maintenance Tickets",
  },
  {
    path: "/payments",
    icon: "fa fa-dollar-sign",
    title: "Payments",
  },
  // parking hidden until post-7th deploy
];
